import Seo from '@/components/feature/Seo';
import Hero from '@/pages/home/components/Hero';
import LatestTracking from '@/pages/home/components/LatestTracking';
import RankingBoard from '@/pages/home/components/RankingBoard';
import CategoryGrid from '@/pages/home/components/CategoryGrid';
import FeaturedTopics from '@/pages/home/components/FeaturedTopics';
import ProgressTimeline from '@/pages/home/components/ProgressTimeline';
import HomeFaq from '@/pages/home/components/HomeFaq';
import SubscribeSection from '@/pages/home/components/SubscribeSection';
import { faqs } from '@/mocks/faqs';

export default function Home() {
  const faqJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((item) => ({
      '@type': 'Question',
      name: item.question,
      acceptedAnswer: { '@type': 'Answer', text: item.answer },
    })),
  };

  const siteJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '看料社',
    description: '专注娱乐热点与网络话题的追踪跟进，按时间线整理最新动态与事件进展。',
    inLanguage: 'zh-CN',
    potentialAction: {
      '@type': 'SearchAction',
      target: `${typeof window !== 'undefined' ? window.location.origin : ''}/tracking?q={search_term_string}`,
      'query-input': 'required name=search_term_string',
    },
  };

  const orgJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '看料社',
    description: '娱乐热点追踪内容站点，强调来源可追溯与时间线完整。',
    email: 'contact@kanliaoshe-mail.com',
  };

  return (
    <>
      <Seo
        title="看料社 - 娱乐热点追踪与最新进展跟进"
        description="看料社专注娱乐热点与网络话题的追踪跟进，按时间线梳理最新动态与事件进展，帮你随时掌握重要节点。看料黑料追踪、跟进、动态一站获取，来源可追溯。"
        keywords="看料社,看料黑料,热点追踪,事件跟进,最新动态,进展时间线,娱乐热点"
        jsonLd={[siteJsonLd, orgJsonLd, faqJsonLd]}
      />
      <Hero />
      <LatestTracking />
      <RankingBoard />
      <CategoryGrid />
      <FeaturedTopics />
      <ProgressTimeline />
      <HomeFaq />
      <SubscribeSection />
    </>
  );
}